import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_MONITOR_DATA,
} from '../../../../actions/actionTypes';

const detectionLinkMonitorData = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_MONITOR_DATA
);

export default detectionLinkMonitorData;
